/* ── 213B §8 / §18 — WHAT A TEXT FIELD THAT IS NOT A SIGN-IN FIELD TELLS THE BROWSER ──
 *
 * Your words, 29/09 and 01/10: Safari offered its saved sign-ins (« clé d'accès
 * enregistrée », « mot de passe enregistré » — staging's and prod's) in the
 * pickers, and its contacts in the modals' fields. The census
 * (docs/213b-deploy-note.md §8.8): Safari's contact AutoFill honours
 * `autocomplete="off"` (and 207 §18's class hides its contacts button); its
 * credential AutoFill does NOT honour « off » on a field it reads as a user
 * name, and reads one from the field's own words and shape — so a field that is
 * not a sign-in carries, besides « off », no login word, no e-mail type, and the
 * managers' documented opt-outs (1Password, LastPass, Bitwarden, Dashlane). One
 * bundle, spread on every such input; `className` adds 207 §18's class itself.
 * WebKit on Linux has no AutoFill: whether Safari stops is Laurent's glance. */
export const NO_AUTOFILL = {
  autoComplete: "off",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: false,
  "data-1p-ignore": "",
  "data-lpignore": "true",
  "data-bwignore": "",
  "data-form-type": "other",
} as const;

/** 207 §18's class, joined to a field's own. */
export const noAutofillClass = (own?: string | null): string => (own ? `${own} no-contact-autofill` : "no-contact-autofill");
